import "./ProfileStyle.css";
import { AES, enc } from "crypto-js";
import React, { useState, useEffect } from "react";
import { BASE_URL } from "../CommonApi";
import swal from "sweetalert";
import Select from "../../../Components/forms/SearchableDropdown";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { CiEdit } from "react-icons/ci";
import DatePicker from "react-datepicker";
import Modal from "react-bootstrap/Modal";
import Alert from "@mui/material/Alert";

function Profile({ navigation }) {
  const [imageChanged, setImageChanged] = useState(false);
  const [image, setImage] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [stampImage, setStampImage] = useState(null);
  const [stampFile, setStampFile] = useState(null);
  const [stampChanged, setStampChanged] = useState(false);
  const [signatureImage, setSignatureImage] = useState(null);
  const [signatureFile, setSignatureFile] = useState(null);
  const [signatureChanged, setSignatureChanged] = useState(false);
  const [existingFiles, setExistingFiles] = useState({
    logo: "",
    signImage: "",
    stampImage: "",
  });
  const [showPassword, setShowPassword] = useState(false); // State variable to manage showing password
  const [gstNumber, setGstNumber] = useState("");
  const encryptedUniqueId = localStorage.getItem("uniqueId1");
  const decryptedUniqueId = AES.decrypt(
    encryptedUniqueId,
    "1234567812345678"
  ).toString(enc.Utf8);
  const profileImageUrl = (fileName) =>
    fileName ? `https://documents.zarpsoftware.in/zarp_images/${fileName}` : null;

  const handleNavigation = (key) => {
    if (navigation.state.routes[navigation.state.index].key !== key) {
      navigation.navigate(key);
    }
  };

  const handleCancelClick = () => {
    handleNavigation("Setting");
  };

  const [startDate, setStartDate] = useState(new Date());
  const [showInvDate, setShowInvDate] = useState(true);

  const normalDateFormat = (date) => {
    if (date) {
      return (
        ("0" + date.getDate()).slice(-2) +
        "-" +
        ("0" + (Number(date.getMonth()) + 1)).slice(-2) +
        "-" +
        date.getFullYear()
      );
    }
    return "";
  };
  const handleDate = (date) => {
    setStartDate(date);
  };
  const [showSalesModal, setShowSalesModal] = useState(false);
  const handleSalesClose = () => setShowSalesModal(false);
  const handleSalesShow = () => setShowSalesModal(true);

  const [formData, setFormData] = useState({
    businessRegistered: "YES",
    gstin: "",
    gstRegisteredOn: normalDateFormat(startDate),
    compositionScheme: "",
    reverseCharge: "",
    importExport: "",
    digitalServices: "",
    compositionSchemePercentage: "",
    customDutyTrackingAccount: "",
  });
  const [validationMessage2, setValidationMessage2] = useState("");

  const handleSaveClick = () => {
    let newValidationMessage = "";

    if (!formData.gstin) {
      newValidationMessage += "Please enter GST Number.\n";
    }

    setValidationMessage2(newValidationMessage);
    // Display a single validation alert if necessary
    if (newValidationMessage) {
      // alert(newValidationMessage.trim()); // Trim trailing newline for better formatting
      return; // Exit function if validation fails
    }

    fetch(BASE_URL + "/insertGstSetting", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({
        uniqueId: decryptedUniqueId,
        ...formData,
        businessRegistered: "YES",
        gstin: String(formData.gstin || "").trim().toUpperCase(),
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          swal({
            icon: "success",
            title: "GST Updated Successfully",
          });
          handleSalesClose();
          getGSTData();
        } else {
          swal({
            icon: "error",
            title: "Failed To Update GST Settting",
          });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const handleRemoveGstNumber = () => {
    swal({
      title: "Remove GST Number?",
      text: "GST registration will be turned off for your profile.",
      icon: "warning",
      buttons: ["Cancel", "Remove"],
      dangerMode: true,
    }).then((shouldRemove) => {
      if (!shouldRemove) {
        return;
      }

      const clearedGstData = {
        businessRegistered: "NO",
        gstin: "",
        gstRegisteredOn: "",
        compositionScheme: false,
        reverseCharge: false,
        importExport: false,
        digitalServices: false,
        compositionSchemePercentage: "",
        customDutyTrackingAccount: "",
      };

      fetch(BASE_URL + "/insertGstSetting", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
        body: JSON.stringify({
          uniqueId: decryptedUniqueId,
          ...clearedGstData,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === "success") {
            setGstNumber("");
            setFormData(clearedGstData);
            setValidationMessage2("");
            handleSalesClose();
            swal({
              icon: "success",
              title: "GST Number Removed",
            });
            getGSTData();
          } else {
            swal({
              icon: "error",
              title: data.responseMessage || "Failed To Remove GST Number",
            });
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          swal({
            icon: "error",
            title: "Failed To Remove GST Number",
          });
        });
    });
  };
  const userId = localStorage.getItem("userId");
  const [itemData, setItemData] = useState({
    organizationName: "",
    email: "",
    industry: "",
    businessLocation: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    zipcode: "",
    // phone: "",
    fax: "",
    website: "",
    paymentAddress: "",
    primaryContact: "",
    password: "",
    financialPeriod: "",
    companyTitle: "",
    companyId: "",
    taxTitle: "",
    taxId: "",
    panNumber: "",
    companyName: "",
    contact: "",
    addressToReceivePayments: "",
    currency: "",
    language: "",
    haveGstNumber: "",
    id: userId,
    uniqueId: decryptedUniqueId,
  });

  const [validationMessage, setValidationMessage] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
    const jwtToken = localStorage.getItem("jwtToken");
    const formData = new FormData();
    let newValidationMessage = "";

    if (itemData.contact && !/^\d{10}$/.test(itemData.contact)) {
      newValidationMessage += "Invalid Contact Number. Please enter a 10-digit number.\n";
    }

    if (itemData.email && !/^[a-z0-9._%+-]+@[a-z]+\.[a-z]{2,4}(\.[a-z]{2,4})?$/.test(itemData.email)) {
      newValidationMessage += "Invalid Email Address. Please enter a valid email.\n";
    }

    if (itemData.zipcode && !/^\d{5,6}$/.test(itemData.zipcode)) {
      newValidationMessage += "Invalid Zipcode. Please enter a valid 5 or 6-digit zipcode.\n";
    }

    setValidationMessage(newValidationMessage);

    // Display a single validation alert if necessary
    if (newValidationMessage) {
      window.scrollTo(0, 0); // Scroll to top
      return;
    }

    // Append text data to formData
    Object.keys(itemData).forEach((key) => {
      if (itemData[key] !== null) {
        formData.append(key, itemData[key]);
      }
    });

    if (!imageFile && existingFiles.logo) {
      formData.append("logo", existingFiles.logo);
    }
    if (!signatureFile && existingFiles.signImage) {
      formData.append("signImage", existingFiles.signImage);
    }
    if (!stampFile && existingFiles.stampImage) {
      formData.append("stampImage", existingFiles.stampImage);
    }

    const submitFormData = (formData) => {
      const apiUrl1 = BASE_URL + "/insertUserProfile";
      const requestOptions1 = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
        body: formData,
      };
      fetch(apiUrl1, requestOptions1)
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else {
            throw new Error("Response was non-200");
          }
        })
        .then((data) => {
          swal({
            icon: "success",
            title: "Profile Updated Successfully",
            text: "",
          });
          fetchData();
        })
        .catch((error) => {
          swal({
            icon: "error",
            title: "Failed to insert data",
          });
        });
    };

    if (imageChanged && imageFile) formData.append("image", imageFile);
    if (stampChanged && stampFile) formData.append("stampPhoto", stampFile);
    if (signatureChanged && signatureFile) formData.append("signPhoto", signatureFile);
    submitFormData(formData);
  };


  const apiUrl = BASE_URL + `/fetchUserProfile`;
  const jwtToken = localStorage.getItem("jwtToken");
  const fetchData = () => {
    fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({ uniqueId: decryptedUniqueId, userId: userId }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          const portfolioItem = data.responseMessage;
          const logoFileName = portfolioItem.logo || "";
          const stampFileName = portfolioItem.stampImage || portfolioItem.stamp_image || "";
          const signatureFileName = portfolioItem.signImage || portfolioItem.sign_image || "";
          setExistingFiles({
            logo: logoFileName,
            stampImage: stampFileName,
            signImage: signatureFileName,
          });
          setImage(profileImageUrl(logoFileName));
          setImageFile(null);
          setImageChanged(false);
          setStampImage(profileImageUrl(stampFileName));
          setStampFile(null);
          setStampChanged(false);
          setSignatureImage(profileImageUrl(signatureFileName));
          setSignatureFile(null);
          setSignatureChanged(false);

          setItemData({
            organizationName: portfolioItem.organizationName,
            email: portfolioItem.email,
            industry: portfolioItem.industry,
            businessLocation: portfolioItem.businessLocation,
            address1: portfolioItem.address1,
            address2: portfolioItem.address2,
            city: portfolioItem.city,
            state: portfolioItem.state,
            zipcode: portfolioItem.zipcode,
            fax: portfolioItem.fax,
            website: portfolioItem.website,
            paymentAddress: portfolioItem.paymentAddress,
            // primaryContact: portfolioItem.primaryContact,
            password: portfolioItem.password,
            taxId: portfolioItem.taxId,
            financialPeriod: portfolioItem.financialPeriod,
            companyTitle: portfolioItem.companyTitle,
            companyId: portfolioItem.companyId,
            taxTitle: portfolioItem.taxTitle,
            panNumber: portfolioItem.panNumber,
            companyName: portfolioItem.companyName,
            contact: portfolioItem.contact,
            addressToReceivePayments: portfolioItem.addressToReceivePayments,
            currency: portfolioItem.currency,
            language: portfolioItem.language,
            haveGstNumber: portfolioItem.haveGstNumber,
            uniqueId: portfolioItem.uniqueId,
            // logo: portfolioItem.logo,
            id: portfolioItem.id,
          });
        } else {
          console.error("Error fetching portfolio data");
        }
      })
      .catch((error) => {
        console.error("Error fetching portfolio data:", error);
      });
  };

  const getGSTData = () => {
    const encryptedUniqueId = localStorage.getItem("uniqueId1");
    const decryptedUniqueId = AES.decrypt(
      encryptedUniqueId,
      "1234567812345678"
    ).toString(enc.Utf8);

    fetch(BASE_URL + `/fetchGst`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({ uniqueId: decryptedUniqueId }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          const Data = Array.isArray(data.responseMessage)
            ? data.responseMessage[0]
            : data.responseMessage;

          if (!Data) {
            setGstNumber("");
            setFormData({
              businessRegistered: "NO",
              gstin: "",
              gstRegisteredOn: "",
              compositionScheme: false,
              reverseCharge: false,
              importExport: false,
              digitalServices: false,
              compositionSchemePercentage: "",
              customDutyTrackingAccount: "",
            });
            return;
          }

          setGstNumber(Data.gstin || "");
          setFormData({
            businessRegistered: Data.businessRegistered || "NO",
            gstin: Data.gstin || "",
            gstRegisteredOn: Data.gstRegisteredOn || "",
            compositionScheme: Data.compositionScheme === "true" ? true : false,
            reverseCharge: Data.reverseCharge === "true" ? true : false,
            importExport: Data.importExport === "true" ? true : false,
            digitalServices: Data.digitalServices === "true" ? true : false,
            compositionSchemePercentage: Data.compositionSchemePercentage,
            customDutyTrackingAccount: Data.customDutyTrackingAccount,
          });
        } else {
          console.error("Failed to fetch GST:", data.responseMessage);
        }
      })
      .catch((error) => {
        console.error("Error fetching GST:", error);
      });
  };

  useEffect(() => {
    fetchData();
    getGSTData();
  }, []);

  const handleInputChange = (e) => {
    setItemData({
      ...itemData,
      [e.target.name]: e.target.value,
    });
  };

  const industryOptions = [
    { value: "Agency or Sales House", label: "Agency or Sales House" },
    { value: "Agriculture", label: "Agriculture" },
    { value: "Art and Design", label: "Art and Design" },
    { value: "Automotive", label: "Automotive" },
    { value: "Construction", label: "Construction" },
    { value: "Consulting", label: "Consulting" },
    { value: "Consumer Packaged Goods", label: "Consumer Packaged Goods" },
    { value: "Education", label: "Education" },
    { value: "Engineering", label: "Engineering" },
    { value: "Entertainment", label: "Entertainment" },
    { value: "Financial Services", label: "Financial Services" },
    {
      value: "Food Services (Restaurants/Fast Food)",
      label: "Food Services (Restaurants/Fast Food)",
    },
    { value: "Gaming", label: "Gaming" },
    { value: "Government", label: "Government" },
    { value: "Health Care", label: "Health Care" },
    { value: "Interior Design", label: "Interior Design" },
    { value: "Internal", label: "Internal" },
    { value: "Legal", label: "Legal" },
    { value: "Manufacturing", label: "Manufacturing" },
    { value: "Marketing", label: "Marketing" },
    { value: "Mining and Logistics", label: "Mining and Logistics" },
    { value: "Non-Profit", label: "Non-Profit" },
    { value: "Publishing and Web Media", label: "Publishing and Web Media" },
    { value: "Real Estate", label: "Real Estate" },
    {
      value: "Retail (E-Commerce and Offline)",
      label: "Retail (E-Commerce and Offline)",
    },
    { value: "Services", label: "Services" },
    { value: "Technology", label: "Technology" },
    { value: "Telecommunications", label: "Telecommunications" },
    { value: "Travel/Hospitality", label: "Travel/Hospitality" },
    { value: "Web Designing", label: "Web Designing" },
    { value: "Web Development", label: "Web Development" },
    { value: "Writers", label: "Writers" },
  ];

  const countryOptions = [
    { value: "Afghanistan", label: "Afghanistan" },
    { value: "Albania", label: "Albania" },
    { value: "Algeria", label: "Algeria" },
    { value: "American Samoa", label: "American Samoa" },
    { value: "Andorra", label: "Andorra" },
    { value: "Angola", label: "Angola" },
    { value: "Anguilla", label: "Anguilla" },
    { value: "Antarctica", label: "Antarctica" },
    { value: "Antigua and Barbuda", label: "Antigua and Barbuda" },
    { value: "Argentina", label: "Argentina" },
    { value: "Armenia", label: "Armenia" },
    { value: "Aruba", label: "Aruba" },
    { value: "Australia", label: "Australia" },
    { value: "Austria", label: "Austria" },
    { value: "Azerbaijan", label: "Azerbaijan" },
    { value: "Bahamas", label: "Bahamas" },
    { value: "Bahrain", label: "Bahrain" },
    { value: "Bangladesh", label: "Bangladesh" },
    { value: "Barbados", label: "Barbados" },
    { value: "Belarus", label: "Belarus" },
    { value: "Belgium", label: "Belgium" },
    { value: "Belize", label: "Belize" },
    { value: "Benin", label: "Benin" },
    { value: "Bermuda", label: "Bermuda" },
    { value: "Bhutan", label: "Bhutan" },
    { value: "Bolivia", label: "Bolivia" },
    { value: "Bosnia and Herzegovina", label: "Bosnia and Herzegovina" },
    { value: "Botswana", label: "Botswana" },
    { value: "Bouvet Island", label: "Bouvet Island" },
    { value: "Brazil", label: "Brazil" },
    {
      value: "British Indian Ocean Territory",
      label: "British Indian Ocean Territory",
    },
    { value: "Brunei Darussalam", label: "Brunei Darussalam" },
    { value: "Bulgaria", label: "Bulgaria" },
    { value: "Burkina Faso", label: "Burkina Faso" },
    { value: "Burundi", label: "Burundi" },
    { value: "Cambodia", label: "Cambodia" },
    { value: "Cameroon", label: "Cameroon" },
    { value: "Canada", label: "Canada" },
    { value: "Cape Verde", label: "Cape Verde" },
    { value: "Cayman Islands", label: "Cayman Islands" },
    { value: "Central African Republic", label: "Central African Republic" },
    { value: "Chad", label: "Chad" },
    { value: "Chile", label: "Chile" },
    { value: "China", label: "China" },
    { value: "Christmas Island", label: "Christmas Island" },
    { value: "Cocos (Keeling) Islands", label: "Cocos (Keeling) Islands" },
    { value: "Colombia", label: "Colombia" },
    { value: "Comoros", label: "Comoros" },
    { value: "Congo", label: "Congo" },
    {
      value: "Congo, the Democratic Republic of the",
      label: "Congo, the Democratic Republic of the",
    },
    { value: "Cook Islands", label: "Cook Islands" },
    { value: "Costa Rica", label: "Costa Rica" },
    { value: "Côte d'Ivoire", label: "Côte d'Ivoire" },
    { value: "Croatia", label: "Croatia" },
    { value: "Cuba", label: "Cuba" },
    { value: "Cyprus", label: "Cyprus" },
    { value: "Czech Republic", label: "Czech Republic" },
    { value: "Denmark", label: "Denmark" },
    { value: "Djibouti", label: "Djibouti" },
    { value: "Dominica", label: "Dominica" },
    { value: "Dominican Republic", label: "Dominican Republic" },
    { value: "Ecuador", label: "Ecuador" },
    { value: "Egypt", label: "Egypt" },
    { value: "El Salvador", label: "El Salvador" },
    { value: "Equatorial Guinea", label: "Equatorial Guinea" },
    { value: "Eritrea", label: "Eritrea" },
    { value: "Estonia", label: "Estonia" },
    { value: "Ethiopia", label: "Ethiopia" },
    {
      value: "Falkland Islands (Malvinas)",
      label: "Falkland Islands (Malvinas)",
    },
    { value: "Faroe Islands", label: "Faroe Islands" },
    { value: "Fiji", label: "Fiji" },
    { value: "Finland", label: "Finland" },
    { value: "France", label: "France" },
    { value: "French Guiana", label: "French Guiana" },
    { value: "French Polynesia", label: "French Polynesia" },
    {
      value: "French Southern Territories",
      label: "French Southern Territories",
    },
    { value: "Gabon", label: "Gabon" },
    { value: "Gambia", label: "Gambia" },
    { value: "Georgia", label: "Georgia" },
    { value: "Germany", label: "Germany" },
    { value: "Ghana", label: "Ghana" },
    { value: "Gibraltar", label: "Gibraltar" },
    { value: "Greece", label: "Greece" },
    { value: "Greenland", label: "Greenland" },
    { value: "Grenada", label: "Grenada" },
    { value: "Guadeloupe", label: "Guadeloupe" },
    { value: "Guam", label: "Guam" },
    { value: "Guatemala", label: "Guatemala" },
    { value: "Guernsey", label: "Guernsey" },
    { value: "Guinea", label: "Guinea" },
    { value: "Guinea-Bissau", label: "Guinea-Bissau" },
    { value: "Guyana", label: "Guyana" },
    { value: "Haiti", label: "Haiti" },
    {
      value: "Heard Island and McDonald Islands",
      label: "Heard Island and McDonald Islands",
    },
    {
      value: "Holy See (Vatican City State)",
      label: "Holy See (Vatican City State)",
    },
    { value: "Honduras", label: "Honduras" },
    { value: "Hong Kong", label: "Hong Kong" },
    { value: "Hungary", label: "Hungary" },
    { value: "Iceland", label: "Iceland" },
    { value: "India", label: "India" },
    { value: "Indonesia", label: "Indonesia" },
    { value: "Iran, Islamic Republic of", label: "Iran, Islamic Republic of" },
    { value: "Iraq", label: "Iraq" },
    { value: "Ireland", label: "Ireland" },
    { value: "Isle of Man", label: "Isle of Man" },
    { value: "Israel", label: "Israel" },
    { value: "Italy", label: "Italy" },
    { value: "Jamaica", label: "Jamaica" },
    { value: "Japan", label: "Japan" },
    { value: "Jersey", label: "Jersey" },
    { value: "Jordan", label: "Jordan" },
    { value: "Kazakhstan", label: "Kazakhstan" },
    { value: "Kenya", label: "Kenya" },
    { value: "Kiribati", label: "Kiribati" },
    {
      value: "Korea, Democratic People's Republic of",
      label: "Korea, Democratic People's Republic of",
    },
    { value: "Korea, Republic of", label: "Korea, Republic of" },
    { value: "Kuwait", label: "Kuwait" },
    { value: "Kyrgyzstan", label: "Kyrgyzstan" },
    {
      value: "Lao People's Democratic Republic",
      label: "Lao People's Democratic Republic",
    },
    { value: "Latvia", label: "Latvia" },
    { value: "Lebanon", label: "Lebanon" },
    { value: "Lesotho", label: "Lesotho" },
    { value: "Liberia", label: "Liberia" },
    { value: "Libyan Arab Jamahiriya", label: "Libyan Arab Jamahiriya" },
    { value: "Liechtenstein", label: "Liechtenstein" },
    { value: "Lithuania", label: "Lithuania" },
    { value: "Luxembourg", label: "Luxembourg" },
    { value: "Macao", label: "Macao" },
    {
      value: "Macedonia, the former Yugoslav Republic of",
      label: "Macedonia, the former Yugoslav Republic of",
    },
    { value: "Madagascar", label: "Madagascar" },
    { value: "Malawi", label: "Malawi" },
    { value: "Malaysia", label: "Malaysia" },
    { value: "Maldives", label: "Maldives" },
    { value: "Mali", label: "Mali" },
    { value: "Malta", label: "Malta" },
    { value: "Marshall Islands", label: "Marshall Islands" },
    { value: "Martinique", label: "Martinique" },
    { value: "Mauritania", label: "Mauritania" },
    { value: "Mauritius", label: "Mauritius" },
    { value: "Mayotte", label: "Mayotte" },
    { value: "Mexico", label: "Mexico" },
    {
      value: "Micronesia, Federated States of",
      label: "Micronesia, Federated States of",
    },
    { value: "Moldova, Republic of", label: "Moldova, Republic of" },
    { value: "Monaco", label: "Monaco" },
    { value: "Mongolia", label: "Mongolia" },
    { value: "Montenegro", label: "Montenegro" },
    { value: "Montserrat", label: "Montserrat" },
    { value: "Morocco", label: "Morocco" },
    { value: "Mozambique", label: "Mozambique" },
    { value: "Myanmar", label: "Myanmar" },
    { value: "Namibia", label: "Namibia" },
    { value: "Nauru", label: "Nauru" },
    { value: "Nepal", label: "Nepal" },
    { value: "Netherlands", label: "Netherlands" },
    { value: "Netherlands Antilles", label: "Netherlands Antilles" },
    { value: "New Caledonia", label: "New Caledonia" },
    { value: "New Zealand", label: "New Zealand" },
    { value: "Nicaragua", label: "Nicaragua" },
    { value: "Niger", label: "Niger" },
    { value: "Nigeria", label: "Nigeria" },
    { value: "Niue", label: "Niue" },
    { value: "Norfolk Island", label: "Norfolk Island" },
    { value: "Northern Mariana Islands", label: "Northern Mariana Islands" },
    { value: "Norway", label: "Norway" },
    { value: "Oman", label: "Oman" },
    { value: "Pakistan", label: "Pakistan" },
    { value: "Palau", label: "Palau" },
    {
      value: "Palestinian Territory, Occupied",
      label: "Palestinian Territory, Occupied",
    },
    { value: "Panama", label: "Panama" },
    { value: "Papua New Guinea", label: "Papua New Guinea" },
    { value: "Paraguay", label: "Paraguay" },
    { value: "Peru", label: "Peru" },
    { value: "Philippines", label: "Philippines" },
    { value: "Pitcairn", label: "Pitcairn" },
    { value: "Poland", label: "Poland" },
    { value: "Portugal", label: "Portugal" },
    { value: "Puerto Rico", label: "Puerto Rico" },
    { value: "Qatar", label: "Qatar" },
    { value: "Réunion", label: "Réunion" },
    { value: "Romania", label: "Romania" },
    { value: "Russian Federation", label: "Russian Federation" },
    { value: "Rwanda", label: "Rwanda" },
    { value: "Saint Barthélemy", label: "Saint Barthélemy" },
    {
      value: "Saint Helena, Ascension and Tristan da Cunha",
      label: "Saint Helena, Ascension and Tristan da Cunha",
    },
    { value: "Saint Kitts and Nevis", label: "Saint Kitts and Nevis" },
    { value: "Saint Lucia", label: "Saint Lucia" },
    {
      value: "Saint Martin (French part)",
      label: "Saint Martin (French part)",
    },
    { value: "Saint Pierre and Miquelon", label: "Saint Pierre and Miquelon" },
    {
      value: "Saint Vincent and the Grenadines",
      label: "Saint Vincent and the Grenadines",
    },
    { value: "Samoa", label: "Samoa" },
    { value: "San Marino", label: "San Marino" },
    { value: "Sao Tome and Principe", label: "Sao Tome and Principe" },
    { value: "Saudi Arabia", label: "Saudi Arabia" },
    { value: "Senegal", label: "Senegal" },
    { value: "Serbia", label: "Serbia" },
    { value: "Seychelles", label: "Seychelles" },
    { value: "Sierra Leone", label: "Sierra Leone" },
    { value: "Singapore", label: "Singapore" },
    { value: "Slovakia", label: "Slovakia" },
    { value: "Slovenia", label: "Slovenia" },
    { value: "Solomon Islands", label: "Solomon Islands" },
    { value: "Somalia", label: "Somalia" },
    { value: "South Africa", label: "South Africa" },
    {
      value: "South Georgia and the South Sandwich Islands",
      label: "South Georgia and the South Sandwich Islands",
    },
    { value: "Spain", label: "Spain" },
    { value: "Sri Lanka", label: "Sri Lanka" },
    { value: "Sudan", label: "Sudan" },
    { value: "Suriname", label: "Suriname" },
    { value: "Svalbard and Jan Mayen", label: "Svalbard and Jan Mayen" },
    { value: "Swaziland", label: "Swaziland" },
    { value: "Sweden", label: "Sweden" },
    { value: "Switzerland", label: "Switzerland" },
    { value: "Syrian Arab Republic", label: "Syrian Arab Republic" },
    { value: "Taiwan, Province of China", label: "Taiwan, Province of China" },
    { value: "Tajikistan", label: "Tajikistan" },
    {
      value: "Tanzania, United Republic of",
      label: "Tanzania, United Republic of",
    },
    { value: "Thailand", label: "Thailand" },
    { value: "Timor-Leste", label: "Timor-Leste" },
    { value: "Togo", label: "Togo" },
    { value: "Tokelau", label: "Tokelau" },
    { value: "Tonga", label: "Tonga" },
    { value: "Trinidad and Tobago", label: "Trinidad and Tobago" },
    { value: "Tunisia", label: "Tunisia" },
    { value: "Turkey", label: "Turkey" },
    { value: "Turkmenistan", label: "Turkmenistan" },
    { value: "Turks and Caicos Islands", label: "Turks and Caicos Islands" },
    { value: "Tuvalu", label: "Tuvalu" },
    { value: "Uganda", label: "Uganda" },
    { value: "Ukraine", label: "Ukraine" },
    { value: "United Arab Emirates", label: "United Arab Emirates" },
    { value: "United Kingdom", label: "United Kingdom" },
    { value: "United States", label: "United States" },
    {
      value: "United States Minor Outlying Islands",
      label: "United States Minor Outlying Islands",
    },
    { value: "Uruguay", label: "Uruguay" },
    { value: "Uzbekistan", label: "Uzbekistan" },
    { value: "Vanuatu", label: "Vanuatu" },
    {
      value: "Venezuela, Bolivarian Republic of",
      label: "Venezuela, Bolivarian Republic of",
    },
    { value: "Viet Nam", label: "Viet Nam" },
    { value: "Virgin Islands, British", label: "Virgin Islands, British" },
    { value: "Virgin Islands, U.S.", label: "Virgin Islands, U.S." },
    { value: "Wallis and Futuna", label: "Wallis and Futuna" },
    { value: "Western Sahara", label: "Western Sahara" },
    { value: "Yemen", label: "Yemen" },
    { value: "Zambia", label: "Zambia" },
    { value: "Zimbabwe", label: "Zimbabwe" },
  ];

  const optionsFinancial = [
    { value: "April - March", label: "April - March" },
    { value: "January - December", label: "January - December" },
    { value: "July - June", label: "July - June" },
    { value: "October - September", label: "October - September" },
  ];

  const optionsTaxIds = [
    { value: "ABN", label: "ABN" },
    { value: "BN", label: "BN" },
    { value: "CST", label: "CST" },
    { value: "ORG", label: "ORG" },
    { value: "TAX", label: "TAX" },
    { value: "VST", label: "VST" },
  ];

  const optionsCompanyIds = [
    { value: "ACN", label: "ACN" },
    { value: "BN", label: "BN" },
    { value: "CN", label: "CN" },
    { value: "CPR", label: "CPR" },
    { value: "CVR", label: "CVR" },
    { value: "DIW", label: "DIW" },
    { value: "KT", label: "KT" },
    { value: "ORG", label: "ORG" },
    { value: "SEC", label: "SEC" },
  ];

  const stateOptions = [
    { label: "Andhra Pradesh", value: "Andhra Pradesh" },
    { label: "Arunachal Pradesh", value: "Arunachal Pradesh" },
    { label: "Assam", value: "Assam" },
    { label: "Bihar", value: "Bihar" },
    { label: "Chhattisgarh", value: "Chhattisgarh" },
    { label: "Goa", value: "Goa" },
    { label: "Gujarat", value: "Gujarat" },
    { label: "Haryana", value: "Haryana" },
    { label: "Himachal Pradesh", value: "Himachal Pradesh" },
    { label: "Jharkhand", value: "Jharkhand" },
    { label: "Karnataka", value: "Karnataka" },
    { label: "Kerala", value: "Kerala" },
    { label: "Madhya Pradesh", value: "Madhya Pradesh" },
    { label: "Maharashtra", value: "Maharashtra" },
    { label: "Manipur", value: "Manipur" },
    { label: "Meghalaya", value: "Meghalaya" },
    { label: "Mizoram", value: "Mizoram" },
    { label: "Nagaland", value: "Nagaland" },
    { label: "Odisha", value: "Odisha" },
    { label: "Punjab", value: "Punjab" },
    { label: "Rajasthan", value: "Rajasthan" },
    { label: "Sikkim", value: "Sikkim" },
    { label: "Tamil Nadu", value: "Tamil Nadu" },
    { label: "Telangana", value: "Telangana" },
    { label: "Tripura", value: "Tripura" },
    { label: "Uttar Pradesh", value: "Uttar Pradesh" },
    { label: "Uttarakhand", value: "Uttarakhand" },
    { label: "West Bengal", value: "West Bengal" },
    {
      label: "Andaman and Nicobar Islands",
      value: "Andaman and Nicobar Islands",
    },
    { label: "Chandigarh", value: "Chandigarh" },
    {
      label: "Dadra and Nagar Haveli and Daman and Diu",
      value: "Dadra and Nagar Haveli and Daman and Diu",
    },
    { label: "Lakshadweep", value: "Lakshadweep" },
    { label: "Delhi", value: "Delhi" },
    { label: "Puducherry", value: "Puducherry" },
  ];

  const handleProfileImage = (file, setPreview, setFile, setChanged) => {
    if (!file) return;
    if (!file.type?.startsWith("image/")) {
      swal({
        icon: "error",
        title: "Please upload a valid image file",
      });
      return;
    }
    setFile(file);
    setChanged(true);
    const reader = new FileReader();
    reader.onload = () => setPreview(reader.result);
    reader.readAsDataURL(file);
  };

  const handleDrop1 = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    handleProfileImage(file, setImage, setImageFile, setImageChanged);
  };

  const handleImageInputChange = (e) => {
    const file = e.target.files[0];
    handleProfileImage(file, setImage, setImageFile, setImageChanged);
  };

  const handleStampInputChange = (e) => {
    handleProfileImage(e.target.files[0], setStampImage, setStampFile, setStampChanged);
  };

  const handleSignatureInputChange = (e) => {
    handleProfileImage(e.target.files[0], setSignatureImage, setSignatureFile, setSignatureChanged);
  };

  const handleRemoveImage = () => {
    setImage(null);
    setImageFile(null);
    setImageChanged(true);
  };
  return (
    <div className="profile-shell">
      <div className="profile-panel">
        <div className="profile-header">
          <div className="profile-title-group">
            <button className="profile-back-btn" onClick={handleCancelClick}>
              <ArrowBackIosIcon fontSize="small" />
              Back
            </button>
            <div>
              <p className="profile-eyebrow">Organization Profile</p>
              <h1 className="profile-heading">Manage your business information and preferences</h1>
            </div>
          </div>

          {/* <div className="profile-actions">
            <div className="status-pill">Autosaved 2s ago</div>
          </div> */}
        </div>

        <Modal show={showSalesModal} onHide={handleSalesClose}>
          <div className="modal-header d-flex align-items-center pb-2 pt-2">
            <h5 className="modal-title fs-5" id="salespersonHead">
              Update GST
            </h5>
            <button type="button" className="btn pr-0" onClick={handleSalesClose}>
              <ion-icon name="close-circle-outline" size="large" style={{ width: "28px" }} />
            </button>
          </div>
          <Modal.Body>
            {validationMessage2 && (
              <Alert severity="error" className="mt-0">
                {validationMessage2.split("\n").map((message, index) => (
                  <div key={index}>{message}</div>
                ))}
              </Alert>
            )}
            <div className="modal-form-grid">
              <div className="field">
                <label>GST Number</label>
                <input
                  className="input-field"
                  placeholder="Enter GST Number"
                  name="gstin"
                  type="text"
                  value={formData.gstin}
                  onChange={(e) => setFormData({ ...formData, gstin: e.target.value })}
                />
              </div>
              <div className="field">
                <label>GST Registered On</label>
                {showInvDate ? (
                  <input
                    className="input-field"
                    type="text"
                    value={formData.gstRegisteredOn}
                    onClick={() => {
                      setShowInvDate(false);
                      setFormData({ ...formData, gstRegisteredOn: normalDateFormat(startDate) });
                      handleDate(startDate);
                    }}
                    readOnly
                  />
                ) : (
                  <div className="customDatePickerWidth">
                    <DatePicker
                      className="input-field"
                      selected={startDate}
                      dateFormat="dd-MM-yyyy"
                      onChange={(date) => handleDate(date)}
                    />
                  </div>
                )}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="p-2 modal-footer-modern">
            {gstNumber && (
              <button type="button" className="btn-action btn-danger-soft" onClick={handleRemoveGstNumber}>
                Remove GST
              </button>
            )}
            <button type="button" className="btn-action btn-secondary" onClick={handleSalesClose}>
              Close
            </button>
            <button type="button" className="btn-action btn-primary" onClick={handleSaveClick}>
              Update
            </button>
          </Modal.Footer>
        </Modal>

        <form className="profile-form" onSubmit={handleSubmit}>
          {validationMessage && (
            <div className="profile-alert">
              <Alert severity="error">
                {validationMessage.split("\n").map((message, index) => (
                  <div key={index}>{message}</div>
                ))}
              </Alert>
            </div>
          )}

          <div className="profile-section">
            <div className="section-grid section-grid-2">
              <div className="upload-panel" onDrop={handleDrop1} onDragOver={(e) => e.preventDefault()}>
                <div className="upload-preview">
                  {image ? <img src={image} alt="Uploaded logo" /> : <div className="upload-placeholder">Logo</div>}
                  <input
                    id="profile-logo-input"
                    type="file"
                    accept="image/*"
                    className="upload-input"
                    onChange={handleImageInputChange}
                  />
                </div>
                <div className="upload-details">
                  <div>
                    <p className="upload-title">Organization logo</p>
                    <p className="upload-copy">Upload a clean brand mark used across invoices and documents.</p>
                  </div>
                  <div className="upload-actions">
                    <label className="btn-action btn-secondary" htmlFor="profile-logo-input">
                      Change logo
                    </label>
                    {image && (
                      <button type="button" className="btn-action btn-ghost" onClick={handleRemoveImage}>
                        Remove
                      </button>
                    )}
                  </div>
                </div>
              </div>

              <div className="upload-panel">
                <div className="upload-preview">
                  {signatureImage ? (
                    <img src={signatureImage} alt="Authorized signature" />
                  ) : (
                    <div className="upload-placeholder">Sign</div>
                  )}
                  <input
                    id="profile-signature-input"
                    type="file"
                    accept="image/*"
                    className="upload-input"
                    onChange={handleSignatureInputChange}
                  />
                </div>
                <div className="upload-details">
                  <div>
                    <p className="upload-title">Authorized signature</p>
                    <p className="upload-copy">Shown at the bottom of invoice, quotation, order, and expense PDFs.</p>
                  </div>
                  <div className="upload-actions">
                    <label className="btn-action btn-secondary" htmlFor="profile-signature-input">
                      Change signature
                    </label>
                  </div>
                </div>
              </div>

              <div className="upload-panel">
                <div className="upload-preview">
                  {stampImage ? (
                    <img src={stampImage} alt="Company stamp" />
                  ) : (
                    <div className="upload-placeholder">Stamp</div>
                  )}
                  <input
                    id="profile-stamp-input"
                    type="file"
                    accept="image/*"
                    className="upload-input"
                    onChange={handleStampInputChange}
                  />
                </div>
                <div className="upload-details">
                  <div>
                    <p className="upload-title">Company stamp</p>
                    <p className="upload-copy">Used with the signature on all printable and downloadable documents.</p>
                  </div>
                  <div className="upload-actions">
                    <label className="btn-action btn-secondary" htmlFor="profile-stamp-input">
                      Change stamp
                    </label>
                  </div>
                </div>
              </div>

              <div className="gst-summary-card">
                <div className="gst-summary-header">
                  <span>GST Number</span>
                  <button type="button" className="gst-edit-btn" onClick={handleSalesShow}>
                    <CiEdit size={16} />
                  </button>
                </div>
                <p className="gst-summary-value">{gstNumber || "Not added"}</p>
                <p className="gst-summary-copy">If your business has GST registration, keep it updated for invoices and returns.</p>
                {gstNumber && (
                  <button type="button" className="btn-action btn-danger-soft gst-remove-btn" onClick={handleRemoveGstNumber}>
                    Remove GST Number
                  </button>
                )}
              </div>
            </div>
          </div>

          <div className="profile-section">
            <div className="section-heading-row">
              <div>
                <p className="section-label">Basic information</p>
                <p className="section-copy">Company name, industry, and registered business location.</p>
              </div>
            </div>
            <div className="fields-grid">
              <div className="field">
                <label>Organization Name</label>
                <input
                  name="companyName"
                  value={itemData.companyName}
                  onChange={handleInputChange}
                  placeholder="Organization Name"
                  className="input-field"
                />
              </div>
              <div className="field">
                <label>Industry</label>
                <Select
                  options={industryOptions}
                  value={industryOptions.find((option) => option.value === itemData.industry)}
                  onChange={(selectedOption) => handleInputChange({ target: { name: "industry", value: selectedOption?.value || "" } })}
                  placeholder="Select industry"
                  styles={selectStyles}
                />
              </div>
              <div className="field">
                <label>Business Location</label>
                <Select
                  options={countryOptions}
                  value={countryOptions.find((option) => option.value === itemData.businessLocation)}
                  onChange={(selectedOption) => handleInputChange({ target: { name: "businessLocation", value: selectedOption?.value || "" } })}
                  placeholder="Select location"
                  styles={selectStyles}
                />
              </div>
            </div>
          </div>

          <div className="profile-section">
            <div className="section-heading-row">
              <div>
                <p className="section-label">Address</p>
                <p className="section-copy">Use the registered business address for invoices and communication.</p>
              </div>
            </div>
            <div className="fields-grid grid-3-col">
              <div className="field">
                <label>Address Line 1</label>
                <input
                  name="address1"
                  value={itemData.address1}
                  onChange={handleInputChange}
                  placeholder="Address Line 1"
                  className="input-field"
                />
              </div>
              <div className="field">
                <label>Address Line 2</label>
                <input
                  name="address2"
                  value={itemData.address2}
                  onChange={handleInputChange}
                  placeholder="Address Line 2"
                  className="input-field"
                />
              </div>
              <div className="field">
                <label>City</label>
                <input
                  name="city"
                  value={itemData.city}
                  onChange={handleInputChange}
                  placeholder="City"
                  className="input-field"
                />
              </div>
              <div className="field">
                <label>State</label>
                <Select
                  options={stateOptions}
                  value={stateOptions.find((option) => option.value === itemData.state)}
                  onChange={(selectedOption) => handleInputChange({ target: { name: "state", value: selectedOption?.value || "" } })}
                  placeholder="Select state"
                  styles={selectStyles}
                />
              </div>
              <div className="field">
                <label>Country</label>
                <Select
                  options={countryOptions}
                  value={countryOptions.find((option) => option.value === itemData.country)}
                  onChange={(selectedOption) => handleInputChange({ target: { name: "country", value: selectedOption?.value || "" } })}
                  placeholder="Select country"
                  styles={selectStyles}
                />
              </div>
              <div className="field">
                <label>Zipcode</label>
                <input
                  name="zipcode"
                  value={itemData.zipcode}
                  onChange={handleInputChange}
                  placeholder="Zipcode"
                  className="input-field"
                />
              </div>
            </div>
          </div>

          <div className="profile-section">
            <div className="section-heading-row">
              <div>
                <p className="section-label">Contact Information</p>
                <p className="section-copy">Primary contact details used for notifications and support.</p>
              </div>
            </div>
            <div className="fields-grid">
              <div className="field">
                <label>Contact Number</label>
                <input
                  name="contact"
                  value={itemData.contact}
                  onChange={handleInputChange}
                  placeholder="Contact Number"
                  className="input-field"
                />
              </div>
              <div className="field">
                <label>Email</label>
                <input
                  name="email"
                  value={itemData.email}
                  onChange={handleInputChange}
                  placeholder="Email"
                  className="input-field"
                />
              </div>
              <div className="field">
                <label>Website</label>
                <input
                  name="website"
                  value={itemData.website}
                  onChange={handleInputChange}
                  placeholder="Website"
                  className="input-field"
                />
              </div>
            </div>
          </div>

          <div className="profile-section">
            <div className="section-heading-row">
              <div>
                <p className="section-label">Business & Tax Details</p>
                <p className="section-copy">Tax IDs, financial year, and company registration details.</p>
              </div>
            </div>
            <div className="fields-grid">
              <div className="field">
                <label>PAN Number</label>
                <input
                  name="panNumber"
                  value={itemData.panNumber}
                  onChange={handleInputChange}
                  placeholder="PAN Number"
                  className="input-field"
                />
              </div>
              <div className="field">
                <label>Financial Period</label>
                <Select
                  options={optionsFinancial}
                  value={optionsFinancial.find((option) => option.value === itemData.financialPeriod)}
                  onChange={(selectedOption) => handleInputChange({ target: { name: "financialPeriod", value: selectedOption?.value || "" } })}
                  placeholder="Select period"
                  styles={selectStyles}
                />
              </div>
              <div className="field">
                <label>Company ID</label>
                <Select
                  options={optionsCompanyIds}
                  value={optionsCompanyIds.find((option) => option.value === itemData.companyId)}
                  onChange={(selectedOption) => handleInputChange({ target: { name: "companyId", value: selectedOption?.value || "" } })}
                  placeholder="Select ID"
                  styles={selectStyles}
                />
              </div>
              <div className="field">
                <label>Tax ID</label>
                <Select
                  options={optionsTaxIds}
                  value={optionsTaxIds.find((option) => option.value === itemData.taxId)}
                  onChange={(selectedOption) => handleInputChange({ target: { name: "taxId", value: selectedOption?.value || "" } })}
                  placeholder="Select tax ID"
                  styles={selectStyles}
                />
              </div>
              <div className="field">
                <label>Password</label>
                <input
                  name="password"
                  value={itemData.password}
                  onChange={handleInputChange}
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  className="input-field"
                />
              </div>
            </div>
          </div>

          <div className="profile-footer-actions">
            <button type="button" className="btn-action btn-secondary" onClick={handleCancelClick}>
              Cancel
            </button>
            <button type="submit" className="btn-action btn-primary">
              Save changes
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

const selectStyles = {
  control: (provided) => ({
    ...provided,
    backgroundColor: "#f8fafc",
    borderColor: "#e5e7eb",
    minHeight: "44px",
    borderRadius: "14px",
    boxShadow: "none",
    paddingLeft: "8px",
    paddingRight: "8px",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#0f172a",
    fontSize: "0.95rem",
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: "14px",
    overflow: "hidden",
    boxShadow: "0 20px 50px rgba(15, 23, 42, 0.12)",
  }),
};

export default Profile;
